'use strict';

var vskoBorderedList = angular.module('vskoBorderedList', []);

vskoBorderedList.directive('vskoBorderedList', [function() {
  return {
    restrict: 'E',
    template: require('./vsko-bordered-list.html'),
    replace: true,
    transclude: {
      contentSlot: 'vskoBorderedListItem'
    },
    scope: {
      horizontal: '='
    }
  }
}]);

vskoBorderedList.directive('vskoBorderedListItem', [function() {
  return {
    restrict: 'E',
    template: require('./vsko-bordered-list-item.html'),
    replace: true,
    transclude: true,
    scope: {}
  }
}]);
